module.exports = __webpack_public_path__ + "images/emoji/trophy.2b0cfe1fb23c2f297f2f.png";